import './appBoot';

$(() => {
    $('.version').text(`${strings.version}  ${altosoft.version}`);
});
